import { useTranslation } from 'react-i18next';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper/modules';
import ArrowLeft from '@/assets/svg/ArrowLeft';
import ArrowRight from '@/assets/svg/ArrowRight';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';


const SliderImgs = ({ data }: { data: { img: string }[] }) => {
    const { t } = useTranslation();

    return (
        <div className="w-full px-5 relative">
            <Swiper
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                loop={true}
                autoplay={{
                    delay: 2000,
                    disableOnInteraction: false,
                }}
                navigation={{
                    nextEl: '.custom-next',
                    prevEl: '.custom-prev',
                }}
                // pagination={{ clickable: false }}
                className="custom-swiper-pagination pt-28"
                speed={800}
                breakpoints={{
                    768: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                    },
                }}
            >
                {data.map((review, index) => (
                    <SwiperSlide key={index} className="h-full">
                        <div className="grid items-stretch w-full h-full">
                            <img
                                loading="lazy"
                                src={review.img}
                                alt={t('productsPage.mainTitle')}
                                className="w-full object-cover rounded-xl shadow lg:h-[600px] md:h-[500px] sm:h-[400px] h-[330px]"
                            />
                        </div>
                    </SwiperSlide>
                ))}
                <div className="custom-navigation ">
                    <button type="button" className="custom-prev z-10" aria-label="Previous">
                        <ArrowLeft className="lg:w-[30px] sm:w-[25px] w-[18px] lg:h-[30px] sm:h-[25px] h-[18px]" />
                    </button>
                    <button type="button" className="custom-next z-10" aria-label="Next">
                        <ArrowRight className="lg:w-[30px] sm:w-[25px] w-[18px] lg:h-[30px] sm:h-[25px] h-[18px]" />
                    </button>
                </div>
            </Swiper>
        </div>
    );
};

export default SliderImgs;
